<div class="project-detail">
  <div class="dash-section">
    <div class="occurrence-graph" *ngIf="chartConfig">
      <div class="occurrence-graph__controls">
        <div class="occurrence-graph__legend">Chart times in UTC</div>
        <ab-time-dur-switch
          [enabled]="!loading"
          [dur]="dur"
          [lastN]="lastN"
          (changed)="loadChart($event)"
        ></ab-time-dur-switch>
      </div>
      <div class="ab-chart">
        <ab-stacked-bar-chart
          class="ab-chart__chart"
          [config]="chartConfig"
        ></ab-stacked-bar-chart>
      </div>
    </div>
  </div>
  <div class="dash-section">
    <ab-project-cards
      [project]="project"
      [diffStatAggregations]="diffStatAggregations"
      [dur]="dur"
      [lastN]="lastN"
    ></ab-project-cards>
  </div>
  <div class="dash-row">
    <div class="dash-row__section">
      <ab-project-hotspots [project]="project" [dur]="dur" [lastN]="lastN">
      </ab-project-hotspots>
    </div>
    <div class="dash-row__section">
      <ab-project-activities [project]="project"></ab-project-activities>
    </div>
  </div>
</div>
